// extracted by mini-css-extract-plugin
module.exports = {"svg":"ReconnectPopup_svg__2LxK0","body":"ReconnectPopup_body__3S4u5","mobile":"ReconnectPopup_mobile__1kpmg"};